const config = [
  {
    header: 'Housing Costs',
    trackingFieldName: 'housing_open',
    className: 'clHousing',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'Median 2-bedroom apartment rent' },
          { key: 'apt_rent_cost', type: 'currency' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Median home price (3BR, 2BA)' },
          { key: 'home_cost', type: 'currency' },
        ],
      },
    ],
  },
  {
    header: 'Transportation Costs',
    trackingFieldName: 'transportation_open',
    className: 'clTransportation',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'Gas (per gallon)' },
          {
            key: 'gas_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'Food Costs',
    trackingFieldName: 'food_open',
    className: 'clFood',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'Bread' },
          {
            key: 'bread_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Dozen eggs' },
          {
            key: 'eggs_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Gallon of milk' },
          {
            key: 'milk_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: '12-inch Pizza Hut pizza' },
          {
            key: 'pizza_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'McDonalds Quarter-Pounder with cheese' },
          {
            key: 'quarter_pounder_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'Entertainment Costs',
    trackingFieldName: 'entertainment_open',
    className: 'clEntertainment',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'Movie ticket' },
          {
            key: 'movie_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Yoga class' },
          {
            key: 'yoga_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: '6-pack Heineken beer' },
          {
            key: 'heineken_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'Healthcare Costs',
    trackingFieldName: 'healthcare_open',
    className: 'clHealthcare',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: "Cost of a doctor's visit" },
          {
            key: 'doctor_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Cost of dentist visit' },
          {
            key: 'dentist_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Cost of optometrist visit' },
          {
            key: 'optometrist_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Cost of lipitor' },
          {
            key: 'lipitor_cost',
            type: 'currency',
            formatterStr: '$0.00',
          },
        ],
      },
    ],
  },
  {
    header: 'School Comparison',
    trackingFieldName: 'school_open',
    className: 'clSchool',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'Average public school rating on GreatSchools.com' },
          {
            key: 'greatschools_rating',
          },
        ],
      },
    ],
  },
];
export default config;
